var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.tagsLoaded
        ? _c("DropdownFilter", {
            attrs: {
              withoutLoading: "",
              customMultiStyleParent: _vm.getcontainerStyle,
              placeholder: "Select tag",
              value: _vm.value,
              multiple: _vm.multiple,
              invalid: _vm.invalid,
              options: _vm.tags,
            },
            on: { input: _vm.handleInput },
          })
        : _c("InputPlaceholder"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }